import { useEffect } from 'react';

export const useGlobalKeydown = (eventHandler: (e: KeyboardEvent) => void) => {
    useEffect(() => {
        document.addEventListener('keydown', eventHandler);
        return () => {
            document.removeEventListener('keydown', eventHandler);
        };
    }, [eventHandler]);
};
